<template>
    <v-dialog
        v-model="dialog"
        width="500"
    >
        <v-card>
            <v-toolbar color="primary" dark flat>
                <v-toolbar-title class="text-capitalize">Allow Partial Match?</v-toolbar-title>
            </v-toolbar>

            <v-card-text class="pt-8 pb-0">
                <p>
                    Allowing partial match for your offer means your send amount can
                    either be matched completely by a single user or by multiple users
                    sending parts of the send amount they matched to your recipient.
                </p>
                <p>
                    In other words, for a 100 (USD/CAD/GBP/EUR) transfer, if partial
                    match is allowed, parts of the 100 such as 10, 22, 34 can be matched
                    and sent to your recipient.
                </p>
                <v-checkbox
                    required
                    v-model="hidePartialMatchDisclaimer"
                    label="Don't show this again"
                    name="hide_partial_match_disclaimer"
                    color="indigo"
                    outlined
                />
            </v-card-text>

            <v-divider></v-divider>

            <v-card-actions>
                <v-btn
                    class="px-6"
                    color="primary"
                    dark
                    depressed
                    large
                    @click="confirm"
                >
                    I understand
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    data() {
        return {
            dialog: false,
            resolve: () => {},
        };
    },
    watch: {
      dialog: function (value, oldValue) {
        if (!value && oldValue) {
          this.resolve(false);
        }
      },
    },
    computed: {
      hidePartialMatchDisclaimer: {
          get() {
              return this.$store.state.hidePartialMatchDisclaimer;
          },
          set(v) {
              this.$store.dispatch('updateHidePartialMatchDisclaimer', v);
          },
      },
    },
    methods: {
        async show() {
          if (this.hidePartialMatchDisclaimer) {
            return true;
          }

          return new Promise((resolve) => {
            this.resolve = resolve;
            this.dialog = true;
          });
        },
        confirm() {
          this.dialog = false;
          this.resolve(true);
        },
    },
};
</script>
